(function () {
  'use strict'

  // App modal
  // ----------------------------------------
  $( '.churchToolsHint' ).on('click', function(e) {
    e.preventDefault();

    const hideAppHint = $(this).hasClass( 'withoutApp' )

    $( '.appInformation' ).toggle(!hideAppHint);
    $( '.cta' ).toggle(hideAppHint);
    
    $( '.initialLink' ).attr( 'href' , $(this).attr( 'href' ))

    openModal( 'churchToolsInformation' )
  })

  // Handle absences
  // ----------------------------------------
  initAbsences();

  // Create notes set
  // ----------------------------------------
  initNotesSet();

  // Preview song texts
  // ----------------------------------------
  $( '.previewSongTexts' ).on('click', function() {
    const modal = $( '#previewTexts' )
    const loadingSpinner = modal.find( '.loadingSpinner' )
    const dynamicContent = modal.find( '.dynamicContent' )

    loadingSpinner.removeClass( 'hidden' );
    dynamicContent.empty();

    openModal( 'previewTexts' )

    const form = $(this).closest( 'form' )
    const url = form.attr( 'action' )
    
    $.ajax({
      url: url.replace( 'anpassen', 'vorschau' ),
      type: 'POST',
      data: form.serialize(),
      success: function (response) {
        loadingSpinner.addClass( 'hidden' );
        dynamicContent.html(response);
      },
      error: function () {}
    })
  })

  var inputPresentation = $( 'input[name="custom_presentation"]' );
  var inputTranslation = $( 'input[name="custom_use_only_translation"]' );

  inputPresentation.on('change input',function(){
    if ($(this).val()) {
      $( '.previewSongTexts' ).removeClass( 'disabled' ).prop( 'disabled', false )
    } else if ($( 'input[name="custom_use_only_translation"]:checked' ).val() != 1) {
      $( '.previewSongTexts' ).addClass( 'disabled' ).prop( 'disabled', true )
    }
  });

  inputTranslation.on('change input',function(){
    if ($(this).val() == 1) {
      $( '.previewSongTexts' ).removeClass( 'disabled' ).prop( 'disabled', false )
    } else if ($( 'input[name="custom_presentation"]' ).val() == '') {      
      $( '.previewSongTexts' ).addClass( 'disabled' ).prop( 'disabled', true )
    }
  });
})()

function initAbsences() {
  $( '.addAbsence, .removeAbsence' ).on('click', function(e) {
    e.preventDefault();

    const absenceContainer = $(this).closest( '.absence' )
    const loadingSpinner = absenceContainer.find( '.loadingSpinner' )

    $(this).hide();
    loadingSpinner.removeClass( 'hidden' );

    const form = $(this).closest( 'form' )
    const url = form.attr( 'action' )

    $.ajax({
        url: url,
        type: 'POST',
        data: form.serialize(),
        success: function (response) {
          loadingSpinner.addClass( 'hidden' )
          absenceContainer.html(response)
          
          $( '.addAbsence, .removeAbsence' ).off()
          initAbsences()
        },
        error: function () {}
    })
  })
}

function initNotesSet() {
  $( '.createNotes' ).on('click', function(e) {
    e.preventDefault();

    const loadingContainer = $(this).closest( '.loadingArea' )
    const loadingSpinner = loadingContainer.find( '.loadingSpinner' )

    $(this).hide();
    loadingSpinner.removeClass( 'hidden' )

    const form = $(this).closest( 'form' )
    const url = form.attr( 'action' )

    $.ajax({
        url: url,
        type: 'POST',
        data: form.serialize(),
        success: function (response) {
          loadingSpinner.addClass( 'hidden' );
          loadingContainer.html(response);
          
          $( '.createNotes' ).off()
          initNotesSet()
        },
        error: function () {}
    })
  })
}